import * as React from "react";
import * as moment from "moment";
import { observer, inject } from "mobx-react";
import { Link } from "react-router-dom";
import MapContainer from "../common/GoogleMapsSale";

import { ConfigurationStore } from "../../stores/ConfigurationStore";
import { HorseForSaleStore } from "../../stores/HorseForSaleStore";

import { GeocodedHorseForSale } from "../../model/HorseForSale";

export interface Props {
    configurationStore?: ConfigurationStore;
    horseForSaleStore?: HorseForSaleStore;
}

export interface State {
    selectedSaleId: number;
    selectedDateId: string;
    geocodedHorseForSaleList: Array<GeocodedHorseForSale>;
    reload: boolean;
}

const NONE_ID = -1;
const NONE_KEY = "-1";
const UNSCHEDULED_KEY = "-2";

@inject("horseForSaleStore")
@inject("configurationStore")
@observer
export class MapAddresses extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selectedSaleId: NONE_ID,
            selectedDateId: "" + NONE_ID,
            geocodedHorseForSaleList: [],
            reload: false
        };
    }

    updateHorseForSaleCoordinatesList = async (saleId: number) => {
        this.props
            .horseForSaleStore!.getHorseForSaleCoordinatesList(saleId)
            .then(response => this.setState({ geocodedHorseForSaleList: response.results }))
            .catch(err => console.error(err));
    };

    markerData() {
        const selectedDateId = this.state.selectedDateId;
        if (selectedDateId === NONE_KEY) {
            return this.state.geocodedHorseForSaleList;
        } else if (selectedDateId === UNSCHEDULED_KEY) {
            return this.state.geocodedHorseForSaleList.filter(sale => !sale.inspectionDate);
        } else {
            return this.state.geocodedHorseForSaleList.filter(
                sale => sale.inspectionDate !== null && moment(sale.inspectionDate).format("YYYY-MM-DD") === selectedDateId
            );
        }
    }

    componentDidMount() {
        // To make sure we have the latest addresses
        this.props.configurationStore!.refresh();
    }

    render() {
        const configurationStore = this.props.configurationStore;
        if (!configurationStore) {
            return <div />;
        }

        const horseForSaleStore = this.props.horseForSaleStore;
        if (!horseForSaleStore) {
            return <div />;
        }

        const selectedHorseForSale = configurationStore.horseSales.find(sale => sale.id === this.state.selectedSaleId);

        return (
            <div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item active" aria-current="page">
                            Google Map of Addresses
                        </li>
                    </ol>
                </nav>
                <div className="content">
                    <div className="row">
                        <div className="col-12">
                            <h1>Google Map of Addresses</h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="card shadown">
                                <div className="card-header">
                                    <form className="form-inline">
                                        <label className="my-1 mr-3" htmlFor="inlineFormCustomSelectPref">
                                            Select Sale:{" "}
                                        </label>
                                        <select
                                            className="custom-select my-1 mr-sm-2"
                                            name="selectedSaleId"
                                            value={this.state.selectedSaleId}
                                            onChange={e => {
                                                e.preventDefault();
                                                const saleId = parseInt(e.target.value, 10);
                                                this.updateHorseForSaleCoordinatesList(saleId);
                                                this.setState({ selectedSaleId: saleId, reload: !this.state.reload });
                                            }}
                                        >
                                            {this.state.selectedSaleId === NONE_ID && <option value={NONE_ID}> Select a Sale... </option>}
                                            {configurationStore.horseSales.map(sale => (
                                                <option key={sale.id} value={sale.id}>
                                                    {sale.name}
                                                </option>
                                            ))}
                                        </select>
                                        {this.state.geocodedHorseForSaleList && this.state.geocodedHorseForSaleList.length > 0 && (
                                            <>
                                                <label className="my-1 mr-3 ml-5" htmlFor="inlineFormCustomSelectPref">
                                                    {" "}
                                                    Select Inspection Date:
                                                </label>
                                                <select
                                                    className="custom-select my-1 mr-sm-2"
                                                    id="inlineFormCustomSelectPref"
                                                    name="selectedDateId"
                                                    value={this.state.selectedDateId}
                                                    onChange={e => {
                                                        e.preventDefault();
                                                        const index = e.target.selectedIndex;
                                                        this.setState({
                                                            selectedDateId: e.target.value,
                                                            reload: !this.state.reload
                                                        });
                                                    }}
                                                >
                                                    <option value={NONE_KEY}>All Dates</option>
                                                    <option value={UNSCHEDULED_KEY}>Unscheduled</option>
                                                    {selectedHorseForSale &&
                                                        selectedHorseForSale.registeredInspectionDates
                                                            .sort((a, b) => a.localeCompare(b))
                                                            .map(date => (
                                                                <option key={date} value={date}>
                                                                    {date}
                                                                </option>
                                                            ))}
                                                </select>
                                            </>
                                        )}
                                    </form>
                                </div>
                                <div className="card-body google-maps d-block" style={{ height: "75vh" }}>
                                    {this.state.geocodedHorseForSaleList && this.state.geocodedHorseForSaleList.length > 0 && (
                                        <MapContainer markersDraggable={false} data={this.markerData()} reload={this.state.reload} />
                                    )}

                                    {this.state.geocodedHorseForSaleList && this.state.geocodedHorseForSaleList.length === 0 && (
                                        <div className="alert alert-warning text-center mx-2 my-2" role="alert">
                                            {" "}
                                            No Horses For Sale founded for this sale.
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/horses-for-sale/MapAddresses.tsx